import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { dashboardActions } from '../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useEmptyVisualization = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { is_customer, can_show_financial_info } = useSelector((state) => state.dashboardReducer);

    const onClick = useCallback(() => {
        dispatch(dashboardActions.onModalMode('visualization'));
    }, []);
    return { is_customer, onClick, can_show_financial_info };
};
